module.exports = __webpack_public_path__ + "media/images/countrysquared/do-8d89c9e9e9fb8eb52987dc541ec4b16f.svg";